import React, { useState } from "react";
import Dropzone from "../dropzone/Dropzone";
import "./Upload.css";
import Progress from "../progress/Progress";
import { API_ROOT } from "../../../../services/apiConfig";
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Auth from '../../../../services/auth';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { acceptedFileTypes } from "../uploadHelper";

const SingleUploader = ({ title, caption, onSaveSuccess, onSaveError, onChangeFile }) => {
    const [state, setState] = useState({
        files: [],
        uploading: false,
        uploadProgress: {},
        successfullUploaded: false,
    });

    const onFilesAdded = (files) => {
        files = files.filter(x => acceptedFileTypes.includes(x.type));
        setState((prevState) => ({
            files: [files[0]],
        }));
        if (onChangeFile) onChangeFile(files[0]);
    };

    const uploadFiles = async () => {
        setState({ ...state, uploadProgress: {}, uploading: true });
        const promises = [];
        state.files.forEach((file) => {
            promises.push(sendRequest(file));
        });
        try {
            await Promise.all(promises);
            if (onSaveSuccess) onSaveSuccess('Upload Successful');
            setState({ ...state, successfullUploaded: true, uploading: false });
        } catch (e) {
            setState({ ...state, successfullUploaded: true, uploading: false });
            if (onSaveError) onSaveError('Error Uploading');
        }
    };

    const handleUpload = async () => {
        await uploadFiles();
    };

    const sendRequest = (file) => {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();

            req.upload.addEventListener("progress", (event) => {
                if (event.lengthComputable) {
                    const copy = { ...state.uploadProgress };
                    copy[file.name] = {
                        state: "pending",
                        percentage: (event.loaded / event.total) * 100,
                    };
                    setState({ ...state, uploadProgress: copy });
                }
            });

            req.upload.addEventListener("load", (event) => {
                const copy = { ...state.uploadProgress };
                copy[file.name] = { state: "done", percentage: 100 };
                setState({ ...state, uploadProgress: copy });
                resolve(req.response);
            });

            req.upload.addEventListener("error", (event) => {
                const copy = { ...state.uploadProgress };
                copy[file.name] = { state: "error", percentage: 0 };
                setState({ ...state, uploadProgress: copy });
                reject(req.response);
            });

            const auth = new Auth();
            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("account", auth.getActiveAccount());
            const endpoint = `${API_ROOT}/api/v1/Transcriptions/UploadInboxDocument`;
            req.open("POST", endpoint);
            req.setRequestHeader('Authorization', 'Bearer ' + auth.getToken());
            req.send(formData);
        });
    };

    const renderProgress = (file) => {
        const uploadProgress = state.uploadProgress ? state.uploadProgress[file.name] : 0;
        if (state.uploading || state.successfullUploaded) {
            return (
                <div className="ProgressWrapper">
                    <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
                    <div style={{ color: 'rgb(34 197 94)' }}>
                        <CheckCircleOutlineIcon />
                    </div>
                </div>
            );
        }
    };

    const renderActions = () => {
        //if (state.successfullUploaded) {
        //    return (
        //        <Button
        //            onClick={() =>
        //                setState({ ...state, files: [], successfullUploaded: false })
        //            }
        //            color="primary"
        //            variant="contained"
        //        >
        //            Clear
        //        </Button>
        //    );
        //} else {
        //    return (
        //        <Button
        //            color="primary"
        //            disabled={state.files.length < 1 || state.uploading}
        //            onClick={handleUpload}
        //            variant="contained"
        //            startIcon={<PublishIcon />}
        //        >
        //            Upload
        //        </Button>
        //    );
        //}
    };

    return (
        <div className="Upload">
            <span className="Title">{title}</span>
            <div className="Content">
                <div>
                    <Dropzone
                        caption={caption}
                        onFilesAdded={onFilesAdded}
                        disabled={state.uploading || state.successfullUploaded}
                    />
                </div>
                <div className="Files">
                    {state.files.map((file) => {
                        return (
                            <div key={file.name} className="Row">
                                <span className="Filename">{file.name}</span>
                                {renderProgress(file)}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="Actions">{renderActions()}</div>
        </div>
    );
};

export default SingleUploader;



// WEBPACK FOOTER //
// ./src/components/Common/CommonUpload/upload/SingleUploader.js